module.exports = {"classes":["dpa-page","header-dark"],"title":"Data Processing Addendum (DPA)","metas":{"description":"This page provides Auth0's DPA, for use by Auth0 prospects and customers who are subject to the European Union's General Data Protection Regulation (GDPR)."},"opengraph":{"og:title":"Data Processing Addendum (DPA)","og:description":"This page provides Auth0's DPA, for use by Auth0 prospects and customers who are subject to the European Union's General Data Protection Regulation (GDPR).","og:url":"https://auth0.com/legal/baseline/dpa"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/legals/dpa/metadata.json
// module id = 1646
// module chunks = 0